import BandedHeader from "@/components/site/BandedHeader";

/**
 * Full-width banded header, then a bordered card sitting cleanly below it.
 * No negative margin overlap — was causing visual blur in night mode.
 */
export default function LegalPage({ eyebrow, title, subtitle, effective, children }) {
  return (
    <>
      <BandedHeader
        eyebrow={eyebrow}
        title={title}
        subtitle={subtitle}
        effective={effective}
      />
      <div className="wrap py-12 md:py-16">
        <div
          className="max-w-[820px] mx-auto rounded-[20px] p-6 md:p-10 leading-relaxed"
          style={{
            background: "var(--card)",
            border: "1px solid var(--border-c)",
            color: "var(--on-surface)",
            boxShadow: "0 30px 60px -30px rgba(0,0,0,0.35)",
          }}
        >
          <article className="prose-content">{children}</article>
        </div>
      </div>
    </>
  );
}
